import Datagent from "datagent";
import {respondData,requestHandle} from "../utils";

const {filter, format, getField, awaitTo} = Datagent.Hooks;

import Fecha from '../utils/type/Fecha';
import {defaults} from "datagent/src/utils";

export const DateFormat = Fecha.format('YYYY-MM-DD HH:mm:ss');
export const DateParse  = Fecha.parse('YYYY-MM-DD HH:mm:ss');

const name = "audit";
const Model = Datagent.Model({
    name,
    fields: {
        'id'                : {type: Number, default: null},
        'firstTargetName'   : {type: String, default:''}, //一级指标
        'firstTargetNum'    : {type: String, default: ''}, // 一级指标编码
        'secondTargetName'  : { type: String, default: ''}, //二级指标
        'secondTargetNum'   : {type: String, default: ''}, // 二级指标编码
        'keyword'           : {type: String, default: ''}, // 关键词
    },
    methods: {
        secondTarget(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).post(`${this._url}/secondTarget`, params);
        },
        batchSecondTarget(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).post(`${this._url}/batch/secondTarget`, params);
        },
        reportStatistics(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/reportStatistics`, { year: params.year })
        },
        inputStatistics(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/inputStatistics`, { year: params.year_input })
        },
        sentimentStatistics(params, opts) { //榜单舆情录入统计
            // see http://47.115.86.102:8888/root/nfcsr-data-backend/-/blob/test/apiDoc/audit.md#5%E6%A6%9C%E5%8D%95%E8%88%86%E6%83%85%E5%BD%95%E5%85%A5%E7%BB%9F%E8%AE%A1
            const { origin } = defaults(opts);
            const { year } = params
            return this.remote(origin).get(`${this._url}/publicSentiment/inputStatistics`, { year })
        },
        publicSentiment(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).post(`${this._url}/publicSentiment`, params);
        },
        negativeSentiment(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).post(`${this._url}/negativeSentiment`, params);
        },
        batchPublicSentiment(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).post(`${this._url}/batch/publicSentiment`, params);
        },
        batchNegativeSentiment(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).post(`${this._url}/batch/negativeSentiment`, params);
        },
        inputListedSentimentStatistics(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/listedSentiment/inputStatistics`, params)
        },
        listedSentimentDefaultTimeScope(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/listedSentiment/defaultTimeScope`, params)
        },
        batchlistedSentiment(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).post(`${this._url}/batch/listedSentiment`, params);
        },
        // listedPunishment(params, opts) {
        //     const { origin } = defaults(opts);
        //     return this.remote(origin).post(`${this._url}/batch/listedPunishment`, params);
        // },
        batchlistedPunishment(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).post(`${this._url}/batch/listedPunishment`, params);
        },
        industryAudit(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).post(`${this._url}/industryAudit/`, params);
        },
        industryAuditCheckAbnormal(params, opts){
          const { origin } = defaults(opts);
          return this.remote(origin).get(`${this._url}/industryAudit/checkAbnormal/`, params);
        },

        //双碳
        carbonThirdTarget(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).post(`${this._url}/carbon/thirdTarget`, params);
        },
        batchCarbonThirdTarget(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).post(`${this._url}/batch/carbon/thirdTarget`, params);
        },
        carbonIndustryAudit(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).post(`${this._url}/carbonIndustryAudit/`, params);
        },
        carbonIndustryAuditCheckAbnormal(params, opts) {
            const { origin } = defaults(opts);
            return this.remote(origin).get(`${this._url}/carbonIndustryAudit/checkAbnormal/`, params);
        },
    },
    hooks: {
        ...Datagent.mapSendHook([format()]),
        secondTarget: { after: [respondData(), requestHandle(), getField("data", format())] },
        reportStatistics: { after: [respondData(), requestHandle(), getField('data', format())] },
        inputStatistics: { after: [respondData(), requestHandle(), getField('data', format())] },
        sentimentStatistics :{ after: [respondData(), requestHandle(), getField('data', format())] },
        publicSentiment: { after: [respondData(), requestHandle(), getField('data', format())] },
        inputListedSentimentStatistics: { after: [respondData(), requestHandle()] },
        listedSentimentDefaultTimeScope: { after: [respondData(), requestHandle()] },
        industryAudit: { after: [respondData(), requestHandle()] },
        industryAuditCheckAbnormal: { after: [respondData(), requestHandle()] },
        carbonThirdTarget: { after: [respondData(), requestHandle(), getField("data", format())] },
        carbonIndustryAudit: { after: [respondData(), requestHandle()] },
        carbonIndustryAuditCheckAbnormal: { after: [respondData(), requestHandle()] },
    }
});

Model.ModelName   = name;
export default Model;
